import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useCloneChapter({ classID }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function cloneChapter(data) {
    return privateFetch
      .post(`/v1/admin/class/${classID}/chapter/clone`, data)
      .then((res) => res.data);
  }

  return useMutation(cloneChapter, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('chapters');
    },
  });
}

export default useCloneChapter;
